export default "__VITE_ASSET__bVRxYSxO__"